var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19629 15.0186H14.7969C16.2119 15.0186 16.9092 14.3281 16.9092 12.9336V6.28223C16.9092 4.88086 16.2119 4.19727 14.7969 4.19727H12.459V3.65723C12.459 2.37207 11.7822 1.77051 10.5449 1.77051H7.44141C6.27246 1.77051 5.52734 2.37207 5.52734 3.65723V4.19727H3.19629C1.78809 4.19727 1.08398 4.88086 1.08398 6.28223V12.9336C1.08398 14.3281 1.78809 15.0186 3.19629 15.0186ZM6.58691 3.58203C6.58691 3.0625 6.89453 2.76855 7.42773 2.76855H10.5654C11.0986 2.76855 11.3994 3.0625 11.3994 3.58203V4.19727H6.58691V3.58203ZM3.20996 13.9248C2.54004 13.9248 2.18457 13.5762 2.18457 12.8789V6.33691C2.18457 5.63281 2.54004 5.29102 3.20996 5.29102H3.97559V13.9248H3.20996ZM5.07617 13.9248V5.29102H12.9102V13.9248H5.07617ZM14.7832 5.29102C15.4531 5.29102 15.8086 5.63281 15.8086 6.33691V12.8789C15.8086 13.5762 15.4531 13.9248 14.7832 13.9248H14.0107V5.29102H14.7832Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.64369998.svg";
export { ForwardRef as ReactComponent };